import React, { useState, useEffect, useRef } from "react";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Modal from "react-bootstrap/Modal";
import Form from "react-bootstrap/Form";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as MetricActions from "../actions/Actions.js";
import RatingBar from "../components/RatingBar.jsx";
import YoutubeModal from "../components/YoutubeModal.jsx";
import DealRow from "../components/DealRow.js";
import RatingCircle from "../components/RatingCircle.jsx";
import SizeScale from "../components/SizeScale.jsx";
import StyleModal from "../components/StyleModal.js";
import QuoteBox from "../components/QuoteBox.jsx";
import { Helmet } from "react-helmet";
import Helper from "../functions/Helper.js";
import { HashLink as Link } from "react-router-hash-link";
import {
  FacebookShareButton,
  TwitterShareButton,
  PinterestShareButton,
  EmailShareButton,
  FacebookIcon,
  TwitterIcon,
  EmailIcon,
  PinterestIcon,
} from "react-share";

import { Swiper, SwiperSlide } from "swiper/react";
import produce from "immer";
import { Waypoint } from "react-waypoint";
import StyleSliderItem from "../components/StyleSliderItem.js";
import Spinner from "react-bootstrap/Spinner";
import styled from "@emotion/styled";
import { useLocation, useNavigate } from "react-router-dom";
import queryString from "query-string";
import WeightScale from "../components/WeightScale.js";
import Gallery from "../components/Gallery.js";
import Button from "react-bootstrap/Button";
import { useShoe } from "../hooks/useShoe.js";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Tooltip from "react-bootstrap/Tooltip";
import ExpertReviewPopup from "../components/ExpertReviewPopup.js";
import UserReviewPopup from "../components/UserReviewPopup.js";
import SimilarComparison from "../components/SimilarComparison.js";
import QuizAdd from "../components/QuizAdd.js";
import useShowSSRVersion from "../hooks/useShowSSRVersion.js";

const mergeHistos = (a, b) => {
  if (!a) {
    return b;
  }
  if (!b) {
    return a;
  }
  return a.map((x, index) => ({
    ...x,
    count: a[index].count + b[index].count,
  }));
};

const getHistoCount = (histo) => {
  if (!histo) {
    return 0;
  }
  return histo.reduce(
    (previousValue, currentValue) => previousValue + currentValue.count,
    0
  );
};

const activeSwitchStyle = {
  cursor: "pointer",
  flex: 1,
  padding: 8,
  textAlign: "center",
  backgroundColor: "#444",
  color: "white",
};
const inactiveSwitchStyle = {
  cursor: "pointer",
  flex: 1,
  padding: 8,
  textAlign: "center",
};

const SmallHeader = styled.h2({
  "@media (min-width:992px)": {
    marginTop: 40,
  },
  fontWeight: 600,
  marginBottom: 5,
  marginTop: 50,
  fontSize: 20,
});

const showShopsAmount = 3;

function getHelmet(shoe) {
  if (shoe) {
    return (
      <Helmet>
        <title>
          {shoe.shoe_name +
            " - Review, Deals" +
            (shoe.discount < 0.95 * shoe.price
              ? " ($" + Number(shoe.discount).toFixed(0) + ")"
              : "") +
            ", Pics of " +
            (shoe.style_amount > 3 ? shoe.style_amount : "all") +
            " Colorways"}
        </title>
        <meta property="og:image:width" content="1170" />
        <meta property="og:image:height" content="658" />
        <meta
          property="og:image"
          content={"https://www.thehoopsgeek.com" + shoe.pictures[1].url}
        />
        <meta
          property="og:title"
          content={shoe.short_summary + " " + shoe.best_text}
        />
        <meta
          name="description"
          content={shoe.short_summary + " " + shoe.best_text}
        />
        <script type="application/ld+json">
          {JSON.stringify(getJsonLD(shoe))}
        </script>
        <link
          rel="preload"
          as="image"
          href={Helper.add_options_img(shoe.pictures[1].master, 585, "webp")}
          imagesrcset={Helper.create_source_set(
            { master: shoe.pictures[1].master, thumbnails: "1" },
            undefined,
            "webp"
          )}
          imagesizes="(max-width:600px) calc(100vw-35px), (max-width:992px) 585px,(max-width: 1200px) 50vw, 585px"
        />
      </Helmet>
    );
  }
}

function getJsonLD(shoe) {
  return {
    "@context": "http://schema.org",
    "@type": "Product",
    name: shoe.shoe_name,
    image:
      shoe.hasOwnProperty("pictures") &&
      "https://www.thehoopsgeek.com/" + shoe.pictures[1].url,
    description: shoe.short_summary,
    brand: shoe.brand,
    ...(shoe.rating !== "NA"
      ? {
          aggregateRating: {
            "@type": "AggregateRating",
            bestRating: "10",
            worstRating: "1",
            ratingValue: shoe.rating,
            ratingCount: shoe.review_amount,
          },
        }
      : {}),
    ...Helper.getOffers(shoe, shoe.colorways),
  };
}

const CategoryBlock = (props) => {
  let [option, setOption] = useState(0);
  let { category, memoShoe, reviews, showYoutube, shoeCount } = props;

  let histo = (passedOption) => {
    if (passedOption === 0) {
      return (
        mergeHistos(
          memoShoe.expert_histo[category],
          memoShoe.user_histo[category]
        ) ?? []
      );
    } else if (passedOption === 1) {
      return memoShoe.expert_histo[category] ?? [];
    } else if (passedOption === 2) {
      return memoShoe.user_histo[category] ?? [];
    }
  };

  return (
    <div key={category}>
      <div className="adthrive-ad"></div>
      <h3
        className="thg_h3_size"
        id={Helper.capitalize(category)}
        style={{ marginBottom: 10, marginTop: 100 }}
      >
        {Helper.capitalize(category)} of the {memoShoe.shoe_name}:
      </h3>
      <div>
        {!["width", "size"].includes(category) && (
          <div style={{ marginBottom: 15 }}>
            {category !== "durability" && (
              <div style={{ fontSize: 16 }}>
                Expert {Helper.capitalize(category)} Rating:&nbsp;
                <span
                  style={{
                    fontWeight: "700",
                    fontSize: 18,
                    color: Helper.get_color(memoShoe[category], "text"),
                  }}
                >
                  {Helper.printRating(memoShoe[category])}
                </span>
                &nbsp;
                {memoShoe[category] !== "NA" && (
                  <span style={{}}>
                    (ranks{" "}
                    <Link
                      style={{ fontWeight: "600" }}
                      to={"/shoe-reviews/?order=desc&sortBy=" + category}
                    >
                      #{memoShoe.ranking[category]} of {shoeCount}
                    </Link>
                    )
                  </span>
                )}
              </div>
            )}
            <div style={{ fontSize: 16 }}>
              User {Helper.capitalize(category)} Rating:&nbsp;
              <span
                style={{
                  fontWeight: "700",
                  fontSize: 18,
                  color: Helper.get_color(memoShoe["user_" + category], "text"),
                }}
              >
                {Helper.printRating(memoShoe["user_" + category])}
              </span>
              &nbsp;
              {memoShoe["user_" + category] !== "NA" && (
                <span style={{}}>
                  (ranks{" "}
                  <Link
                    style={{ fontWeight: "600" }}
                    to={"/shoe-reviews/?order=desc&sortBy=user_" + category}
                  >
                    #{memoShoe.ranking["user_" + category]} of {shoeCount}
                  </Link>
                  )
                </span>
              )}
            </div>
          </div>
        )}
        <Form.Control
          style={{ maxWidth: 300, fontSize: 14, marginBottom: 15 }}
          onChange={(e) => {
            setOption(Number(e.target.value));
          }}
          value={option}
          as="select"
        >
          <option key={0} value={0}>
            {getHistoCount(histo(0))} Total Ratings
          </option>
          <option key={1} value={1}>
            {getHistoCount(histo(1))} Expert Ratings
          </option>
          <option key={2} value={2}>
            {getHistoCount(histo(2))} User Ratings
          </option>
        </Form.Control>
        <div style={{ marginBottom: 40 }}>
          {histo(option).map((row, index) => (
            <div key={index} style={{ display: "flex", marginBottom: 5 }}>
              <div style={{ flexBasis: 100, fontSize: 14 }}>{row.label}</div>
              <div style={{ flexBasis: 200 }}>
                <div
                  style={{
                    width: "100%",
                    height: 20,
                    backgroundColor: "rgb(239, 239, 239)",
                  }}
                >
                  <OverlayTrigger
                    placement="bottom"
                    overlay={
                      <Tooltip style={{ fontSize: 14 }} id="tooltip">
                        {row.count + " ratings " + row.description}
                      </Tooltip>
                    }
                  >
                    <div
                      style={{
                        transition: "width 0.5s",
                        backgroundColor: "orange",
                        height: 20,
                        width:
                          (row.count / getHistoCount(histo(option))) * 100 +
                          "%",
                      }}
                    ></div>
                  </OverlayTrigger>
                </div>
              </div>
              <div style={{ textAlign: "right", flexBasis: 36, fontSize: 14 }}>
                {row.count}
              </div>
            </div>
          ))}
        </div>

        {category !== "durability" && reviews[category].length > 0 && (
          <div className="adthrive-ad"></div>
        )}

        {category !== "durability" && reviews[category].length === 0 && (
          <div style={{ marginBottom: 20, fontSize: 16 }}>
            No expert reviews for this category so far.
          </div>
        )}

        {category !== "durability" &&
          reviews[category].map((review, index) => {
            return (
              <div key={review.review_id}>
                {(index + 1) % 3 === 0 &&
                  index + 1 < reviews[category].length && (
                    <div className="adthrive-ad" />
                  )}
                <QuoteBox
                  pickReview={() =>
                    props.setPickedReview({
                      ...review,
                      shoe_name: memoShoe.shoe_name,
                    })
                  }
                  showYoutube={showYoutube}
                  {...review}
                  category={category}
                />
              </div>
            );
          })}
      </div>
    </div>
  );
};

const ExpertReviews = (props) => {
  let { memoShoe, showYoutube, shoeCount } = props;
  let expertSampling = memoShoe.reviews.map((x) => x.rating);
  let expertHisto = [
    {
      label: "10 - Amazing",
      count: expertSampling.filter((x) => Math.round(x) === 10).length,
      description: ">9.5",
    },
    {
      label: "9 - Great",
      count: expertSampling.filter((x) => Math.round(x) === 9).length,
      description: "8.5-9.5",
    },
    {
      label: "8 - Good",
      count: expertSampling.filter((x) => Math.round(x) === 8).length,
      description: "7.5-8.5",
    },
    {
      label: "7 - Average",
      count: expertSampling.filter((x) => Math.round(x) === 7).length,
      description: "6.5-7.5",
    },
    {
      label: "6 - Subpar",
      count: expertSampling.filter((x) => Math.round(x) === 6).length,
      description: "5.5-6.5",
    },
    {
      label: "5 - Poor",
      count: expertSampling.filter((x) => Math.round(x) === 5).length,
      description: "<5.5",
    },
  ];

  return (
    <>
      <div>
        <div style={{ marginBottom: 15, fontSize: 16 }}>
          Expert Rating:&nbsp;
          <span
            style={{
              fontSize: 18,
              fontWeight: "700",
              color: Helper.get_color(memoShoe["rating"], "text"),
            }}
          >
            {Helper.printRating(memoShoe["rating"])}
          </span>
          &nbsp;
          <span style={{}}>
            (ranks{" "}
            <Link
              style={{ fontWeight: "600" }}
              to={"/shoe-reviews/?order=desc&sortBy=rating"}
            >
              #{memoShoe.ranking["rating"]} of {shoeCount}
            </Link>
            )
          </span>
        </div>

        <div style={{ marginBottom: 40 }}>
          {expertHisto.map((row, index) => (
            <div key={index} style={{ display: "flex", marginBottom: 5 }}>
              <div style={{ flexBasis: 100, fontSize: 14 }}>{row.label}</div>
              <div style={{ flexBasis: 200 }}>
                <div
                  style={{
                    width: "100%",
                    height: 20,
                    backgroundColor: "rgb(239, 239, 239)",
                  }}
                >
                  <OverlayTrigger
                    placement="bottom"
                    overlay={
                      <Tooltip style={{ fontSize: 14 }} id="tooltip">
                        {row.count + " ratings " + row.description}
                      </Tooltip>
                    }
                  >
                    <div
                      style={{
                        backgroundColor: "orange",
                        height: 20,
                        width: (row.count / expertSampling.length) * 100 + "%",
                      }}
                    ></div>
                  </OverlayTrigger>
                </div>
              </div>
              <div style={{ textAlign: "right", flexBasis: 36, fontSize: 14 }}>
                {row.count}
              </div>
            </div>
          ))}
        </div>

        <div className="adthrive-ad" />

        {memoShoe.reviews.map((review, index) => {
          return (
            <div key={review.review_id}>
              {(index + 1) % 3 === 0 && <div className="adthrive-ad" />}
              <QuoteBox
                pickReview={() =>
                  props.setPickedReview({
                    ...review,
                    shoe_name: memoShoe.shoe_name,
                  })
                }
                showYoutube={showYoutube}
                {...review}
                category={"overall"}
              />
            </div>
          );
        })}
      </div>
    </>
  );
};

const UserReviews = (props) => {
  let { memoShoe, shoeCount } = props;
  let userHisto = memoShoe.user_histo.rating;
  const navigate = useNavigate();
  return (
    <>
      <div style={{ marginBottom: 15, fontSize: 16 }}>
        User Rating:&nbsp;
        <span
          style={{
            fontSize: 18,
            fontWeight: "700",
            color: Helper.get_color(memoShoe["user_rating"], "text"),
          }}
        >
          {Helper.printRating(memoShoe["user_rating"])}
        </span>
        &nbsp;
        <span style={{}}>
          (ranks{" "}
          <Link
            style={{ fontWeight: "600" }}
            to={"/shoe-reviews/?order=desc&sortBy=user_rating"}
          >
            #{memoShoe.ranking["user_rating"]} of {shoeCount}
          </Link>
          )
        </span>
      </div>
      <div style={{ marginBottom: 20 }}>
        {userHisto.map((row, index) => (
          <div key={index} style={{ display: "flex", marginBottom: 5 }}>
            <div style={{ flexBasis: 100, fontSize: 14 }}>{row.label}</div>
            <div style={{ flexBasis: 200 }}>
              <div
                style={{
                  width: "100%",
                  height: 20,
                  backgroundColor: "rgb(239, 239, 239)",
                }}
              >
                <OverlayTrigger
                  placement="bottom"
                  overlay={
                    <Tooltip style={{ fontSize: 14 }} id="tooltip">
                      {row.count + " ratings " + row.description}
                    </Tooltip>
                  }
                >
                  <div
                    style={{
                      backgroundColor: "orange",
                      height: 20,
                      width:
                        (row.count / memoShoe.user_review_amount) * 100 + "%",
                    }}
                  ></div>
                </OverlayTrigger>
              </div>
            </div>
            <div style={{ textAlign: "right", flexBasis: 36, fontSize: 14 }}>
              {row.count}
            </div>
          </div>
        ))}
      </div>

      <Button
        style={{ marginBottom: 40, fontSize: 14 }}
        size="sm"
        onClick={() =>
          navigate("/shoe-reviews/rating?shoe_id=" + memoShoe.shoe_id)
        }
        variant="outline-dark"
      >
        Add Your Review
      </Button>

      <div className="adthrive-ad" />

      {memoShoe.user_reviews.slice(0, 5).map((review, index) => {
        return (
          <div key={review.user_review_id}>
            {(index + 1) % 3 === 0 && <div className="adthrive-ad" />}
            <QuoteBox
              pickReview={() =>
                props.setPickedUserReview({
                  ...review,
                  shoe_name: memoShoe.shoe_name,
                })
              }
              openStylePopup={props.openStylePopup}
              by="user"
              {...review}
              category={"overall"}
            />
          </div>
        );
      })}
    </>
  );
};

function Shoe(props) {
  //console.log(props);
  const updatedAdThrive = useRef(false);
  const [sortingStyles, setSortingStyles] = useState(false);
  const [activeStyleId, setActiveStyleId] = useState(0);
  const [showStyleModal, setShowStyleModal] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [videoID, setVideoID] = useState("");
  const [swiper, setSwiper] = useState(null);
  const [currentFooterPosition, setCurrentFooterPosition] = useState(0);
  const [linkId, setLinkId] = useState("");
  const [currentPosition, setCurrentPosition] = useState(0);
  const [showingMoreShops, setShowingMoreShops] = useState(false);
  const [showGallery, setShowGallery] = useState(false);
  const [activeSlide, setActiveSlide] = useState(0);
  const [ratingSwitch, setRatingSwitch] = useState("EXPERT");
  const [pickedReview, setPickedReview] = useState(false);
  const [pickedUserReview, setPickedUserReview] = useState(false);

  const showSSRVersion = useShowSSRVersion();

  const navigate = useNavigate();

  const openStylePopup = (style_id) => {
    setShowStyleModal(true);
    setLinkId("user_review");
    setActiveStyleId(style_id);
  };

  let shoe_name = props.url;

  let memoShoe = useShoe(
    shoe_name.toLowerCase(),
    props.currentShoe,
    props.data,
    props.actions.shoeData
  );

  let location = useLocation();

  useEffect(() => {
    let parsed = queryString.parse(location.search);
    if (Object.prototype.hasOwnProperty.call(parsed, "style_id")) {
      setShowStyleModal(true);
      setLinkId("swiper");
      setActiveStyleId(parsed.style_id);
    }
  }, [location]);

  const showYoutube = (videoID) => {
    setVideoID(videoID);
    setShowModal(true);
  };

  const sortStyles = (styles, sortBy) => {
    let returnStyles = produce(styles, (draftStyles) => {
      if (sortBy == 0) {
        draftStyles.sort((a, b) => Helper.sortStylesByPrice(a, b));
      } else if (sortBy == 1) {
        draftStyles.sort((a, b) => Helper.sortStylesByLikes(a, b));
      }
    });
    return returnStyles;
  };

  if (!memoShoe) {
    return (
      <div>
        <Spinner animation="border" variant="primary" />
      </div>
    );
  }

  let calcSortStylesBy = showSSRVersion ? "0" : props.sortStylesBy;

  let shareUrl =
    memoShoe &&
    "https://www.thehoopsgeek.com/shoe-reviews/" +
      memoShoe.url.toLowerCase() +
      "/";
  let pinterestMedia =
    memoShoe && memoShoe.pictures.hasOwnProperty(1)
      ? "https://www.thehoopsgeek.com" + memoShoe.pictures[1].url
      : "";
  let sortedStyles =
    memoShoe &&
    memoShoe.hasOwnProperty("styles") &&
    sortStyles(memoShoe.styles, calcSortStylesBy);
  let filteredStyles =
    sortedStyles && sortedStyles.filter((x) => x.colorways.length > 0);
  let pictureArray =
    memoShoe &&
    Object.values(memoShoe.pictures).sort((a, b) => a.type - b.type);
  let categories = [
    "traction",
    "cushion",
    "materials",
    "support",
    "fit",
    "outdoor",
    "width",
    "size",
  ];
  let reviews = {};
  let firstColorway =
    filteredStyles &&
    filteredStyles.sort((a, b) => Helper.sortStylesByPrice(a, b))[0]
      ?.colorways[0];

  let activeStyle = sortedStyles
    ? {
        ...sortedStyles.filter((style) => style.style_id === activeStyleId)[0],
        shoe_name: memoShoe.shoe_name,
        shoe_url: memoShoe.url,
      }
    : false;

  if (memoShoe.hasOwnProperty("reviews")) {
    categories.forEach((category) => {
      reviews[category] = memoShoe.reviews.filter((x) => x[category] !== "-1");
    });
  }

  const colorways_by_shop = Helper.sort_colorways_by_shop(memoShoe.colorways);
  const resells_by_shop = Helper.sort_colorways_by_shop(memoShoe.resells);

  let colorways_and_resells_by_shop = [
    ...colorways_by_shop,
    ...resells_by_shop,
  ];

  if (memoShoe !== null) {
    let release_date = Helper.getDateFromMysql(memoShoe.release_date);
    //let colorways_by_shop=Helper.sort_colorways_by_shop(memoShoe.colorways);

    return (
      <div style={{ paddingBottom: 100, boxSizing: "border-box!important" }}>
        {/*<style>{`
          .adthrive-ad{
            margin-top:10px;
            margin-bottom:10px;
            background-color:yellow;
            height:300px;
          }`}
        </style>*/}
        <ExpertReviewPopup
          hide={() => setPickedReview(false)}
          review={pickedReview}
        />
        <UserReviewPopup
          hide={() => setPickedUserReview(false)}
          review={pickedUserReview}
        />

        {pictureArray && showGallery && (
          <Gallery
            activeSlide={activeSlide}
            setActiveSlide={setActiveSlide}
            showGallery={showGallery}
            closeGallery={() => {
              setShowGallery(false);
            }}
            pictures={pictureArray}
          />
        )}
        {getHelmet(memoShoe)}
        {activeStyle && showStyleModal && (
          <Modal
            dialogClassName="thg_style_modal"
            onHide={() => {
              setShowStyleModal(false);
            }}
            show={showStyleModal}
          >
            <StyleModal
              linkId={linkId}
              hideModal={() => {
                setShowStyleModal(false);
                if (location.search !== "") {
                  navigate("/shoe-reviews/" + memoShoe.url + "/");
                }
              }}
              activeStyle={activeStyle}
            />
          </Modal>
        )}

        <Modal
          size="lg"
          onHide={() => {
            setShowModal(false);
          }}
          show={showModal}
        >
          <YoutubeModal videoID={videoID} />
        </Modal>
        <div>
          <p style={{ marginBottom: 10, marginTop: 10 }} id="breadcrumbs_react">
            <span>
              <Link
                onClick={() => {
                  props.actions.switchValue(0);
                }}
                to={"/shoe-reviews/"}
              >
                Basketball Shoes
              </Link>{" "}
              &nbsp;/&nbsp;
              <span className="breadcrumb_last">{memoShoe.shoe_name}</span>
            </span>
          </p>
        </div>

        <div
          style={{
            display: "flex",
            alignItems: "center",
            marginBottom: "0.5rem",
          }}
        >
          <h1 className="thg_h1_size" style={{ marginBottom: 0 }}>
            {memoShoe.shoe_name}
          </h1>

          {(showSSRVersion ? [] : props.favs).filter(
            (x) => x === memoShoe.shoe_id
          ).length > 0 && (
            <i
              title="Remove from Favourites"
              onClick={(x) => {
                props.removeFav(memoShoe);
              }}
              className="fas fa-star"
              style={{
                fontSize: 30,
                marginLeft: 5,
                color: "orange",
                cursor: "pointer",
              }}
            />
          )}
        </div>

        <div
          style={{
            display: "flex",
            flexWrap: "wrap",
            fontSize: 14,
            marginBottom: 10,
          }}
        >
          <div style={{ fontSize: 14 }}>
            Released {release_date.getMonth() + 1}/{release_date.getFullYear()},{" "}
            {memoShoe.style}
            {memoShoe.player !== "No Signature" && (
              <>
                ,{" "}
                <Link
                  style={{ fontWeight: 600 }}
                  to={
                    "/shoe-reviews/" +
                    memoShoe.player
                      .toLowerCase()
                      .replace(" ", "-")
                      .replace("’", "") +
                    "-basketball-shoes/"
                  }
                >
                  {memoShoe.player}
                </Link>
              </>
            )}
            ,{"\u00A0"}
          </div>
          {(showSSRVersion ? [] : props.favs).filter(
            (x) => x === memoShoe.shoe_id
          ).length === 0 ? (
            <div
              onClick={(x) => {
                props.actions.addFav(memoShoe);
              }}
              style={{ alignItems: "center", display: "flex" }}
            >
              <div style={{ marginRight: 5, cursor: "pointer" }}>
                Add to Favourites
              </div>
              <i
                style={{
                  fontSize: 16,
                  lineHeight: "22.4px",
                  color: "orange",
                  cursor: "pointer",
                }}
                className="far fa-star"
              ></i>
            </div>
          ) : (
            <div
              onClick={(x) => {
                props.actions.removeFav(memoShoe);
              }}
              style={{ alignItems: "center", display: "flex" }}
            >
              <div style={{ marginRight: 5, cursor: "pointer" }}>
                Remove from Favourites
              </div>
              <i
                style={{
                  fontSize: 16,
                  lineHeight: "22.4px",
                  cursor: "pointer",
                  color: "#666666",
                }}
                className="far fa-trash-alt"
              ></i>
            </div>
          )}
        </div>

        <div
          css={{
            paddingBottom: 40,
            "@media (min-width:992px)": {
              display: "grid",
              gridTemplateColumns: "58.33% 41.67%",
              gridTemplateRows: "auto",
            },
          }}
        >
          <div
            css={{
              "@media (max-width:991px)": { margin: "0px -20px 0px" },
              "@media (min-width:992px)": {
                marginRight: 50,
                backgroundColor: "#f8f8f8",
              },
              textAlign: "center",
              gridRow: "2 / span 3",
              gridColumn: "1",
            }}
          >
            <div
              className="hover-swiper"
              style={{ flex: 1, alignItems: "center", position: "relative" }}
            >
              <Swiper
                onActiveIndexChange={(x) => {
                  setActiveSlide(x.activeIndex);
                }}
                className="gallery"
                lazy={{ loadPrevNext: true }}
                key={memoShoe.shoe_id}
                style={{ backgroundColor: "#f9f9f9" }}
                watchOverflow={true}
                onSwiper={(x) => {
                  setSwiper(x);
                }}
                navigation={{
                  nextEl: ".swiper-button-next",
                  prevEl: ".swiper-button-prev",
                }}
                pagination={{ clickable: false }}
              >
                {pictureArray.map((picture, index) => {
                  return (
                    <SwiperSlide key={picture.master}>
                      <div
                        style={{
                          width: "100%",
                          height: "100%",
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "flex-end",
                        }}
                      >
                        <div style={{ maxWidth: 600, flex: 1 }}>
                          <div
                            css={{
                              "@media (max-width:991px)": {
                                paddingBottom: "85%",
                                position: "relative",
                              },
                              "@media (min-width:992px)": {
                                paddingBottom: "75%",
                                position: "relative",
                              },
                            }}
                          >
                            <div
                              css={{
                                position: "absolute",
                                bottom: 50,
                                top: 20,
                                left: 10,
                                right: 10,
                              }}
                            >
                              <picture>
                                <source
                                  type="image/webp"
                                  data-srcset={Helper.create_source_set(
                                    { master: picture.master, thumbnails: "1" },
                                    undefined,
                                    "webp"
                                  )}
                                  sizes="(max-width:600px) calc(100vw-35px), (max-width:992px) 585px,(max-width: 1200px) 50vw, 585px"
                                />
                                <source
                                  type="image/png"
                                  data-srcset={Helper.create_source_set({
                                    master: picture.master,
                                    thumbnails: "1",
                                  })}
                                  sizes="(max-width:600px) calc(100vw-35px), (max-width:992px) 585px,(max-width: 1200px) 50vw, 585px"
                                />
                                {index === 0 ? (
                                  <picture>
                                    <source
                                      type="image/webp"
                                      srcSet={Helper.create_source_set(
                                        {
                                          master: picture.master,
                                          thumbnails: "1",
                                        },
                                        undefined,
                                        "webp"
                                      )}
                                      sizes="(max-width:600px) calc(100vw-35px), (max-width:992px) 585px,(max-width: 1200px) 50vw, 585px"
                                    />
                                    <source
                                      type="image/png"
                                      srcSet={Helper.create_source_set({
                                        master: picture.master,
                                        thumbnails: "1",
                                      })}
                                      sizes="(max-width:600px) calc(100vw-35px), (max-width:992px) 585px,(max-width: 1200px) 50vw, 585px"
                                    />
                                    <img
                                      onClick={() => {
                                        setShowGallery(true);
                                      }}
                                      width={picture.width}
                                      height={picture.height}
                                      css={{
                                        cursor: "zoom-in",
                                        maxHeight: 400,
                                        maxWidth: 550,
                                        transform:
                                          picture.mirror === "1" &&
                                          "scaleX(-1)",
                                        objectPosition: "bottom center",
                                        objectFit: "contain",
                                        width: "100%",
                                        height: "100%",
                                      }}
                                      src={Helper.add_options_img(
                                        picture.master,
                                        585
                                      )}
                                      sizes="(max-width:600px) calc(100vw-35px), (max-width:992px) 585px,(max-width: 1200px) 50vw, 585px"
                                      alt={memoShoe.shoe_name}
                                      srcSet={Helper.create_source_set({
                                        master: picture.master,
                                        thumbnails: "1",
                                      })}
                                    />
                                  </picture>
                                ) : (
                                  <picture>
                                    <source
                                      type="image/webp"
                                      data-srcset={Helper.create_source_set(
                                        {
                                          master: picture.master,
                                          thumbnails: "1",
                                        },
                                        undefined,
                                        "webp"
                                      )}
                                      sizes="(max-width:600px) calc(100vw-35px), (max-width:992px) 585px,(max-width: 1200px) 50vw, 585px"
                                    />
                                    <source
                                      type="image/png"
                                      data-srcset={Helper.create_source_set({
                                        master: picture.master,
                                        thumbnails: "1",
                                      })}
                                      sizes="(max-width:600px) calc(100vw-35px), (max-width:992px) 585px,(max-width: 1200px) 50vw, 585px"
                                    />
                                    <img
                                      onClick={() => {
                                        setShowGallery(true);
                                      }}
                                      width={picture.width}
                                      height={picture.height}
                                      css={{
                                        cursor: "zoom-in",
                                        maxHeight: 400,
                                        maxWidth: 550,
                                        transform:
                                          picture.mirror === "1" &&
                                          "scaleX(-1)",
                                        objectPosition: "bottom center",
                                        objectFit: "contain",
                                        width: "100%",
                                        height: "100%",
                                      }}
                                      data-src={Helper.add_options_img(
                                        picture.master,
                                        585
                                      )}
                                      sizes="(max-width:600px) calc(100vw-35px), (max-width:992px) 585px,(max-width: 1200px) 50vw, 585px"
                                      className="swiper-lazy"
                                      alt={memoShoe.shoe_name}
                                      data-srcset={Helper.create_source_set({
                                        master: picture.master,
                                        thumbnails: "1",
                                      })}
                                    />
                                  </picture>
                                )}
                              </picture>
                            </div>
                          </div>
                        </div>
                      </div>
                      {index !== 0 && (
                        <div className="swiper-lazy-preloader"></div>
                      )}
                    </SwiperSlide>
                  );
                })}

                <div className="swiper-button-next next-button-hover" />
                <div className="swiper-button-prev prev-button-hover" />
              </Swiper>
            </div>
          </div>

          <div style={{ gridRow: 2, gridColumn: "2", paddingTop: 10 }}>
            <div style={{ display: "flex" }}>
              <div style={{ flex: 1, paddingRight: 20, textAlign: "right" }}>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "flex-end",
                    marginTop: 10,
                  }}
                >
                  <RatingCircle
                    containerStyle={{
                      flexBasis: "110px",
                      height: 110,
                      flexGrow: 0,
                    }}
                    of={props.data.length}
                    {...memoShoe}
                    textStyle={{ fontSize: 45, lineHeight: "45px" }}
                  />
                </div>
                <div style={{ fontWeight: 600, fontSize: 16, marginTop: 5 }}>
                  EXPERT RATING
                </div>
                <div
                  onClick={() =>
                    document.getElementById("overall").scrollIntoView({
                      behavior: "smooth",
                      block: "start",
                      inline: "nearest",
                    })
                  }
                  style={{
                    color: "var(--primary-color-600)",
                    cursor: "pointer",
                    fontSize: 14,
                    fontWeight: 600,
                    lineHeight: "14px",
                  }}
                >
                  {memoShoe.review_amount} reviews
                </div>
              </div>

              <div style={{ flex: 1, paddingLeft: 20, textAlign: "left" }}>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "flex-start",
                    marginTop: 10,
                  }}
                >
                  <RatingCircle
                    containerStyle={{
                      flexBasis: "110px",
                      height: 110,
                      flexGrow: 0,
                    }}
                    of={props.data.length}
                    {...memoShoe}
                    rating={memoShoe.user_rating}
                    textStyle={{ fontSize: 45, lineHeight: "45px" }}
                  />
                </div>
                <div style={{ fontWeight: 600, fontSize: 16, marginTop: 5 }}>
                  USER RATING
                </div>
                <div
                  onClick={() =>
                    document.getElementById("user_overall").scrollIntoView({
                      behavior: "smooth",
                      block: "start",
                      inline: "nearest",
                    })
                  }
                  style={{
                    color: "var(--primary-color-600)",
                    cursor: "pointer",
                    fontSize: 14,
                    fontWeight: 600,
                    lineHeight: "14px",
                  }}
                >
                  {memoShoe.user_review_amount} ratings
                </div>
                <Button
                  style={{ fontSize: 12, marginTop: 10 }}
                  size="sm"
                  onClick={() =>
                    navigate("/shoe-reviews/rating?shoe_id=" + memoShoe.shoe_id)
                  }
                  variant="outline-dark"
                >
                  Add Rating
                </Button>
              </div>
            </div>
            {memoShoe.short_summary !== "" && (
              <div
                style={{
                  fontSize: 16,
                  textAlign: "center",
                  marginTop: 20,
                  marginBottom: 20,
                  fontStyle: "italic",
                }}
              >
                <i className="fas fa-quote-left" style={{ marginRight: 5 }} />
                {memoShoe.short_summary}
              </div>
            )}
            {memoShoe.best_text !== "" && (
              <>
                <div className="adthrive-ad-desktop-hidden"></div>
                <SmallHeader>Best Suitable For:</SmallHeader>
                <div style={{ fontSize: 16 }}>{memoShoe.best_text}</div>
              </>
            )}
          </div>

          <div
            style={{
              maxWidth: 450,
              gridRow: 5,
              gridColumn: "1",
              marginTop: 20,
              marginBottom: 20,
            }}
          >
            <SmallHeader>Price Comparison:</SmallHeader>
            {!memoShoe.hasOwnProperty("colorways") ? (
              <div
                style={{ display: "flex", alignItems: "center", marginTop: 20 }}
              >
                <Spinner animation="border" variant="primary" />
                <span style={{ marginLeft: 10 }}>...loading shops</span>
              </div>
            ) : (
              <>
                <div style={{ marginBottom: 15, fontSize: 16 }}>
                  Available at {colorways_and_resells_by_shop.length}{" "}
                  {colorways_and_resells_by_shop.length === 1
                    ? "shop"
                    : "shops"}{" "}
                  | Official Retail Price: ${memoShoe.price}
                </div>

                {colorways_and_resells_by_shop
                  .slice(0, showingMoreShops ? 100 : showShopsAmount)
                  .map((colorways, index) => {
                    return (
                      <DealRow
                        key={index}
                        style={{ borderTopWidth: index === 0 ? 0 : 1 }}
                        trackingId={"price_comp"}
                        colorway={colorways.colorways[0]}
                      />
                    );
                  })}

                {showingMoreShops &&
                  colorways_and_resells_by_shop.length > showShopsAmount && (
                    <div
                      onClick={() => {
                        setShowingMoreShops(false);
                      }}
                      style={{
                        fontSize: 16,
                        cursor: "pointer",
                        color: "var(--primary-color-700)",
                        fontWeight: 600,
                        marginTop: 10,
                      }}
                    >
                      <i className="fas fa-arrow-up" /> See less shops
                    </div>
                  )}
                {colorways_and_resells_by_shop.length === 0 && (
                  <div>No shops found</div>
                )}

                {!showingMoreShops &&
                  colorways_and_resells_by_shop.length > showShopsAmount && (
                    <div
                      onClick={() => {
                        setShowingMoreShops(true);
                      }}
                      style={{
                        fontSize: 16,
                        cursor: "pointer",
                        color: "var(--primary-color-600)",
                        fontWeight: "bold",
                        marginTop: 10,
                      }}
                    >
                      <i className="fas fa-arrow-down" /> See all{" "}
                      {colorways_and_resells_by_shop.length} shops
                    </div>
                  )}
              </>
            )}
          </div>

          <div className="adthrive-ad-desktop-hidden"></div>

          <div style={{ gridRow: 5, gridColumn: "2", marginTop: 20 }}>
            <SmallHeader>Category Performance Ratings:</SmallHeader>

            <div
              style={{
                display: "flex",
                maxWidth: "100%",
                width: 320,
                marginTop: 10,
                marginBottom: 20,
                borderRadius: 10,
                fontWeight: 600,
                fontSize: 13,
                overflow: "hidden",
                border: "1px solid #ccc",
              }}
            >
              <div
                onClick={() => setRatingSwitch("EXPERT")}
                style={
                  ratingSwitch === "EXPERT"
                    ? activeSwitchStyle
                    : inactiveSwitchStyle
                }
              >
                <i
                  style={{
                    marginLeft: -13,
                    marginRight: 5,
                    visibility:
                      ratingSwitch === "EXPERT" ? "visible" : "hidden ",
                  }}
                  className="fas fa-check"
                />
                Expert Ratings ({memoShoe.review_amount})
              </div>
              <div
                onClick={() => setRatingSwitch("USER")}
                style={
                  ratingSwitch === "EXPERT"
                    ? inactiveSwitchStyle
                    : activeSwitchStyle
                }
              >
                <i
                  style={{
                    marginLeft: -13,
                    marginRight: 5,
                    visibility:
                      ratingSwitch === "EXPERT" ? "hidden" : "visible ",
                  }}
                  className="fas fa-check"
                />
                User Ratings ({memoShoe.user_review_amount})
              </div>
            </div>
            {ratingSwitch === "EXPERT" ? (
              <>
                <RatingBar category="Traction" rating={memoShoe.traction} />
                <RatingBar category="Cushion" rating={memoShoe.cushion} />
                <RatingBar category="Materials" rating={memoShoe.materials} />
                <RatingBar category="Support" rating={memoShoe.support} />
                <RatingBar category="Fit" rating={memoShoe.fit} />
                <RatingBar category="Outdoor" rating={memoShoe.outdoor} />
              </>
            ) : (
              <>
                <RatingBar
                  category="Traction"
                  rating={memoShoe.user_traction}
                />
                <RatingBar category="Cushion" rating={memoShoe.user_cushion} />
                <RatingBar
                  category="Materials"
                  rating={memoShoe.user_materials}
                />
                <RatingBar category="Support" rating={memoShoe.user_support} />
                <RatingBar category="Fit" rating={memoShoe.user_fit} />
                <RatingBar category="Outdoor" rating={memoShoe.user_outdoor} />
                <RatingBar
                  category="Durability"
                  rating={memoShoe.user_durability}
                />
              </>
            )}
          </div>

          <div
            style={{
              gridRow: memoShoe.rating === "NA" ? 3 : 4,
              gridColumn: "2",
              paddingBottom: 10,
            }}
          >
            <SmallHeader css={{ "@media min-width:992px": { marginTop: 30 } }}>
              Weight & Sizing:
            </SmallHeader>
            <div
              style={{
                marginBottom: isNaN(memoShoe.size) ? 15 : 10,
                display: "flex",
                alignItems: "flex-end",
                fontSize: 16,
                marginTop: 20,
              }}
            >
              <div style={{ flex: 0, flexBasis: 70, lineHeight: 1 }}>
                Weight:
              </div>
              {memoShoe.weight_min === "NA" ? (
                <div
                  style={{
                    lineHeight: 1,
                    paddingLeft: 20,
                    fontWeight: 600,
                    color: "#555",
                  }}
                >
                  NA
                </div>
              ) : (
                <div
                  style={{
                    justifyContent: "flex-end",
                    textAlign: "right",
                    display: "flex",
                    flex: 2,
                    paddingLeft: 20,
                  }}
                >
                  <WeightScale
                    shoe_name={memoShoe.shoe_name}
                    weight_min={memoShoe.weight_min}
                    weight_max={memoShoe.weight_max}
                  />
                </div>
              )}
            </div>

            <div
              style={{
                marginBottom: isNaN(memoShoe.width) ? 15 : 10,
                display: "flex",
                alignItems: "flex-end",
                fontSize: 16,
              }}
            >
              <div style={{ flex: 0, flexBasis: 70, lineHeight: 1 }}>
                Sizing:
              </div>
              {isNaN(memoShoe.size) ? (
                <div
                  style={{
                    lineHeight: 1,
                    paddingLeft: 20,
                    fontWeight: 600,
                    color: "#555",
                  }}
                >
                  NA
                </div>
              ) : (
                <div
                  onClick={() => {
                    Helper.gaEvent("reviews", "SizeScale", "Size");
                    document
                      .getElementById("Size")
                      .scrollIntoView({ behavior: "smooth", block: "start" });
                  }}
                  style={{
                    justifyContent: "flex-end",
                    textAlign: "right",
                    display: "flex",
                    flex: 2,
                    paddingLeft: 20,
                  }}
                >
                  <SizeScale
                    shoe_name={memoShoe.shoe_name}
                    percent={memoShoe.size}
                    type="size"
                  />
                </div>
              )}
            </div>

            <div
              style={{
                marginBottom: 5,
                display: "flex",
                alignItems: "flex-end",
                fontSize: 16,
              }}
            >
              <div style={{ flex: 0, flexBasis: 70, lineHeight: 1 }}>
                Width:
              </div>
              {isNaN(memoShoe.width) ? (
                <div
                  style={{
                    lineHeight: 1,
                    paddingLeft: 20,
                    fontWeight: 600,
                    color: "#555",
                  }}
                >
                  NA
                </div>
              ) : (
                <div
                  onClick={() => {
                    Helper.gaEvent("reviews", "SizeScale", "Width");
                    document
                      .getElementById("Width")
                      .scrollIntoView({ behavior: "smooth", block: "start" });
                  }}
                  style={{
                    justifyContent: "flex-end",
                    textAlign: "right",
                    display: "flex",
                    flex: 2,
                    paddingLeft: 20,
                  }}
                >
                  <SizeScale
                    shoe_name={memoShoe.shoe_name}
                    percent={memoShoe.width}
                    type="width"
                  />
                </div>
              )}
            </div>
          </div>
        </div>

        <div className="adthrive-ad" />

        <SmallHeader>Comparison to Similar Shoes:</SmallHeader>

        <SimilarComparison shoe={memoShoe} overview={props.overview} />

        <div className="adthrive-ad" />

        <div className="hover-swiper" style={{ marginTop: 60 }}>
          <div className="d-md-flex" style={{ marginBottom: 10 }}>
            <div className="mb-md-2">
              <div>
                <Link
                  to={
                    "/shoe-reviews/" +
                    memoShoe.url.toLowerCase() +
                    "-colorways/"
                  }
                  id="colorways"
                  style={{
                    color: "#2d3748",
                    fontWeight: 600,
                    margin: 0,
                    fontSize: 20,
                  }}
                >
                  Colorways of {memoShoe.shoe_name}:
                </Link>
              </div>
              <Link
                style={{ fontSize: 16, fontWeight: "bold" }}
                to={
                  "/shoe-reviews/" + memoShoe.url.toLowerCase() + "-colorways/"
                }
              >
                See all {sortedStyles.length} colorways
              </Link>
            </div>

            <div className="d-flex justify-content-md-end" style={{ flex: 1 }}>
              <Form.Control
                css={{
                  "@media (min-width:768px)": {
                    marginLeft: 20,
                    marginTop: 0,
                    fontSize: 16,
                  },
                  marginTop: 15,
                  width: "auto",
                }}
                value={calcSortStylesBy}
                onChange={(e) => {
                  setSortingStyles(true);
                  setTimeout(() => {
                    setSortingStyles(false);
                  }, 500);
                  props.actions.setSortStylesBy(e.target.value);
                }}
                as="select"
              >
                <option value={0}>sorted by price</option>
                <option value={1}>sorted by likes</option>
              </Form.Control>
            </div>
          </div>
          <div
            style={{ position: "relative", opacity: sortingStyles ? 0.5 : 1 }}
          >
            {sortedStyles && sortedStyles.length > 0 ? (
              <Swiper
                navigation={{
                  nextEl: ".swiper-button-next",
                  prevEl: ".swiper-button-prev",
                }}
                style={{ margin: -5, padding: 5 }}
                slidesPerView="auto"
                spaceBetween={15}
              >
                {sortedStyles.map((style, index) => {
                  return (
                    <SwiperSlide key={style.style_id} style={{ width: 200 }}>
                      <StyleSliderItem
                        textContainerStyle={{ padding: 5 }}
                        showCounter
                        imageProps={{ padding: "10px 10px 20px" }}
                        styleItem={style}
                        swiperWidth={200}
                        imageHeight={200}
                        onClick={() => {
                          setShowStyleModal(true);
                          setActiveStyleId(style.style_id);
                          setLinkId("swiper");
                        }}
                      />
                    </SwiperSlide>
                  );
                })}
                <div
                  style={{ top: "10%" }}
                  className="swiper-button-next next-button-hover"
                />
                <div
                  style={{ top: "10%" }}
                  className="swiper-button-prev prev-button-hover"
                />
              </Swiper>
            ) : (
              <div style={{ fontSize: 14 }}>
                No colorways added for {memoShoe.shoe_name}
              </div>
            )}

            {sortingStyles && (
              <div
                style={{ position: "absolute", zIndex: 1, top: 50, left: 20 }}
              >
                <Spinner animation="border" variant="primary" />
              </div>
            )}
          </div>
        </div>

        <Waypoint
          onPositionChange={(x) => setCurrentPosition(x.currentPosition)}
        />
        {memoShoe.consensus !== "" && (
          <h2 className="thg_h2_size" style={{ marginTop: 80 }}>
            {memoShoe.shoe_name + " Review"}
          </h2>
        )}
        <Row style={{ marginTop: 0 }}>
          <Col lg={8}>
            {(memoShoe.pros.length > 0 || memoShoe.cons.length > 0) && (
              <Row style={{ marginTop: 15, marginBottom: 20 }}>
                <Col xl={6} md={6}>
                  <div
                    style={{ fontSize: 20, marginBottom: 10, fontWeight: 600 }}
                  >
                    Pros:
                  </div>
                  <div
                    style={{ marginBottom: 20, paddingLeft: 10, fontSize: 16 }}
                  >
                    {memoShoe.pros.map((pro) => {
                      return (
                        <div key={pro.pro_id} style={{ display: "flex" }}>
                          <i
                            style={{
                              fontSize: 20,
                              lineHeight: "29px",
                              color: "#48BB78",
                            }}
                            className="fas fa-check-circle"
                          ></i>
                          <div
                            key={pro.pro_id}
                            style={{
                              marginLeft: 10,
                              lineHeight: 1.6,
                              paddingBottom: 10,
                            }}
                          >
                            {pro.text}
                          </div>
                        </div>
                      );
                    })}
                  </div>
                </Col>
                <Col xl={6} md={6}>
                  <div
                    style={{ fontSize: 20, marginBottom: 10, fontWeight: 600 }}
                  >
                    Cons:
                  </div>
                  <div
                    style={{ marginBottom: 20, paddingLeft: 10, fontSize: 16 }}
                  >
                    {memoShoe.cons.map((con) => {
                      return (
                        <div key={con.con_id} style={{ display: "flex" }}>
                          <i
                            style={{
                              fontSize: 20,
                              lineHeight: "29px",
                              color: "rgb(229, 62, 62)",
                            }}
                            className="fas fa-times-circle"
                          ></i>
                          <div
                            key={con.con_id}
                            style={{
                              marginLeft: 10,
                              lineHeight: 1.6,
                              paddingBottom: 10,
                            }}
                          >
                            {con.text}
                          </div>
                        </div>
                      );
                    })}
                  </div>
                </Col>
              </Row>
            )}

            {memoShoe.consensus !== "" && (
              <>
                <div className="adthrive-ad"></div>
                <h3
                  className="thg_h5_size"
                  style={{ fontWeight: 600, marginTop: 40, marginBottom: 20 }}
                >
                  Performance of the {memoShoe.shoe_name}:
                </h3>
                <div style={{ marginBottom: 20, paddingRight: 20 }}>
                  <div style={{ whiteSpace: "pre-line", fontSize: 16 }}>
                    {memoShoe.consensus}
                  </div>
                  <div
                    style={{
                      fontWeight: "bold",
                      marginTop: 15,
                      fontSize: 16,
                      cursor: "pointer",
                      color: "var(--primary-color-600)",
                    }}
                    onClick={() => {
                      Helper.gaEvent("reviews", "click", "See all reviews");
                      document.getElementById("overall").scrollIntoView({
                        behavior: "smooth",
                        block: "start",
                        inline: "nearest",
                      });
                    }}
                  >
                    {" "}
                    <i className="fas fa-arrow-circle-right"></i> See all{" "}
                    {memoShoe.review_amount} reviews
                  </div>
                </div>
              </>
            )}

            <div className="adthrive-ad"></div>

            {memoShoe.hasOwnProperty("reviews") ? (
              <div style={{ marginBottom: 40 }}>
                <h3
                  className="thg_h3_size"
                  id="overall"
                  style={{ marginBottom: 10, marginTop: 100 }}
                >
                  Expert Reviews of the {memoShoe.shoe_name}:
                </h3>

                {memoShoe.review_amount > 0 ? (
                  <ExpertReviews
                    setPickedReview={setPickedReview}
                    memoShoe={memoShoe}
                    showYoutube={showYoutube}
                    shoeCount={props.overview.length}
                  />
                ) : (
                  <div style={{ fontSize: 16 }}>
                    No expert opinions found so far
                  </div>
                )}
                {props.visitedQuiz ? <div class="adthrive-ad" /> : <QuizAdd />}

                <div>
                  <h3
                    className="thg_h3_size"
                    id="user_overall"
                    style={{ marginBottom: 10, marginTop: 100 }}
                  >
                    User Reviews of the {memoShoe.shoe_name}:
                  </h3>
                  {/*
                  <div style={{marginBottom:10,fontSize:16}}>
                    There are {memoShoe.user_reviews_summary.review_amount} user ratings with an average rating of&nbsp;
                    <span style={{fontSize:20,fontWeight:"700",color:Helper.get_color(memoShoe.user_reviews_summary.rating,"text")}}>
                      {Helper.printRating(memoShoe.user_reviews_summary.rating)}
                    </span>
                  </div>*/}
                  {memoShoe.user_review_amount > 0 ? (
                    <UserReviews
                      setPickedUserReview={setPickedUserReview}
                      openStylePopup={openStylePopup}
                      memoShoe={memoShoe}
                      shoeCount={props.overview.length}
                    />
                  ) : (
                    <>
                      <div style={{ fontSize: 16, marginBottom: 10 }}>
                        No user reviews so far
                      </div>
                      <Button
                        style={{ marginBottom: 40, fontSize: 14 }}
                        size="sm"
                        onClick={() =>
                          navigate(
                            "/shoe-reviews/rating?shoe_id=" + memoShoe.shoe_id
                          )
                        }
                        variant="outline-dark"
                      >
                        Add Your Review
                      </Button>
                    </>
                  )}
                  {memoShoe.user_review_amount > 5 && (
                    <div style={{ marginTop: -20, marginBottom: 30 }}>
                      <Link
                        to={
                          "/shoe-reviews/user-reviews?shoe_id=" +
                          memoShoe.shoe_id
                        }
                        style={{
                          fontSize: 18,
                          lineHeight: 1.2,
                          color: "black",
                          fontWeight: 600,
                        }}
                      >
                        See all {memoShoe.user_review_amount} reviews
                      </Link>
                    </div>
                  )}
                </div>

                {[
                  "traction",
                  "cushion",
                  "materials",
                  "support",
                  "fit",
                  "durability",
                  "outdoor",
                  "width",
                  "size",
                ].map((category) => (
                  <CategoryBlock
                    setPickedReview={setPickedReview}
                    key={category}
                    shoeCount={props.overview.length}
                    category={category}
                    memoShoe={memoShoe}
                    reviews={reviews}
                    showYoutube={showYoutube}
                  />
                ))}

                <div style={{}}>
                  <h3 style={{ marginBottom: 30, marginTop: 100 }}>
                    Share this article:
                  </h3>
                  <div style={{ flex: 1, display: "flex" }}>
                    <div style={{ cursor: "pointer" }}>
                      <FacebookShareButton
                        beforeOnClick={() => {
                          Helper.gaEvent("reviews", "share", "Facebook");
                        }}
                        url={shareUrl}
                      >
                        <FacebookIcon size={50} />
                      </FacebookShareButton>
                    </div>
                    <div style={{ paddingLeft: 5, cursor: "pointer" }}>
                      <TwitterShareButton
                        beforeOnClick={() => {
                          Helper.gaEvent("reviews", "share", "Twitter");
                        }}
                        title={
                          memoShoe.shoe_name +
                          ": Average Expert Rating " +
                          memoShoe.rating +
                          "/10"
                        }
                        url={shareUrl}
                      >
                        <TwitterIcon size={50} />
                      </TwitterShareButton>
                    </div>
                    <div style={{ paddingLeft: 5, cursor: "pointer" }}>
                      <PinterestShareButton
                        beforeOnClick={() => {
                          Helper.gaEvent("reviews", "share", "Pinterest");
                        }}
                        media={pinterestMedia}
                        url={shareUrl}
                      >
                        <PinterestIcon size={50} />
                      </PinterestShareButton>
                    </div>
                    <div style={{ paddingLeft: 5, cursor: "pointer" }}>
                      <EmailShareButton
                        subject={memoShoe.shoe_name + " Performance Review"}
                        beforeOnClick={() => {
                          Helper.gaEvent("reviews", "share", "Email");
                        }}
                        url={shareUrl}
                      >
                        <EmailIcon size={50} />
                      </EmailShareButton>
                    </div>
                  </div>
                </div>
              </div>
            ) : (
              <div>Loading</div>
            )}
          </Col>

          <Col className="d-none d-lg-block" lg={{ span: 4 }}>
            <div
              css={{
                "::-webkit-scrollbar": { display: "none" },
                scrollbarWidth: "none",
                visibility: currentPosition === "above" ? "visible" : "hidden",
                opacity: currentPosition === "above" ? 1 : 0,
                transition: "opacity 0.3s ease-in",
                position: "sticky",
                maxHeight: "100vh",
                overflow: "scroll",
                paddingBottom: 100,
                top: 10,
              }}
            >
              <div style={{ display: "flex", justifyContent: "flex-end" }}>
                <div style={{ width: 300, paddingLeft: 10, paddingBottom: 30 }}>
                  <div
                    style={{
                      fontWeight: 600,
                      marginBottom: 10,
                      fontSize: 16,
                      marginTop: 20,
                    }}
                  >
                    Sharing is caring:
                  </div>
                  <div style={{ flex: 1, display: "flex", marginBottom: 20 }}>
                    <div style={{ cursor: "pointer" }}>
                      <FacebookShareButton
                        beforeOnClick={() => {
                          Helper.gaEvent("reviews", "share", "Facebook");
                        }}
                        url={shareUrl}
                      >
                        <FacebookIcon size={50} />
                      </FacebookShareButton>
                    </div>
                    <div style={{ paddingLeft: 5, cursor: "pointer" }}>
                      <TwitterShareButton
                        beforeOnClick={() => {
                          Helper.gaEvent("reviews", "share", "Twitter");
                        }}
                        title={
                          memoShoe.shoe_name +
                          ": Average Expert Rating " +
                          memoShoe.rating +
                          "/10"
                        }
                        url={shareUrl}
                      >
                        <TwitterIcon size={50} />
                      </TwitterShareButton>
                    </div>
                    <div style={{ paddingLeft: 5, cursor: "pointer" }}>
                      <PinterestShareButton
                        beforeOnClick={() => {
                          Helper.gaEvent("reviews", "share", "Pinterest");
                        }}
                        media={pinterestMedia}
                        url={shareUrl}
                      >
                        <PinterestIcon size={50} />
                      </PinterestShareButton>
                    </div>
                    <div style={{ paddingLeft: 5, cursor: "pointer" }}>
                      <EmailShareButton
                        subject={memoShoe.shoe_name + " Performance Review"}
                        beforeOnClick={() => {
                          Helper.gaEvent("reviews", "share", "Email");
                        }}
                        url={shareUrl}
                      >
                        <EmailIcon size={50} />
                      </EmailShareButton>
                    </div>
                  </div>
                  <div className="adthrive-manual-sidebar"></div>
                </div>
              </div>

              {/*filteredStyles && filteredStyles.length>0 &&
                <div style={{display:"flex",justifyContent:"flex-end"}}>
                  <div style={{width:300}}>
                    <div style={{flexFlow:"wrap",display:"flex",flex:1}}>
                      {filteredStyles.map((style,index)=>{
                        return(
                          <div key={style.style_id} style={{paddingBottom:20,paddingLeft:10}}>
                            <StyleSliderItem showLikeButton={false} showDiscount={false} imageHeight={110} key={style.style_id} styleItem={style}
                              onClick={()=>{
                                setShowStyleModal(true);
                                setActiveStyleId(style.style_id);
                                setLinkId("sidebar");}
                              }
                              swiperWidth={140}/>
                          </div>
                        )}
                      )}
                    </div>
                  </div>
                </div>
              */}
            </div>
          </Col>
        </Row>

        {/*firstColorway &&
          <div className="d-lg-none" css={{
              "@media (max-width:325px)":{paddingLeft:10,paddingRight:10},
              paddingBottom:"calc(10px + env(safe-area-inset-bottom,10))",paddingLeft:20,paddingRight:20,paddingTop:10,transition:"bottom 0.5s",bottom:currentPosition==="above" && currentFooterPosition ==="below"  ? 0 : "calc(-80px - env(safe-area-inset-bottom,0))",zIndex: 1,justifyContent:"center",display: "flex",borderTop: "1px solid #ddd",position: "fixed",backgroundColor:"#fafafa",left: 0,right: 0,height:"calc(80px +env(safe-area-inset-bottom,0) )"}}>
            <div style={{flex:1,flexDirection:"row",display:"flex"}}>
              <div style={{cursor:"pointer"}} onClick={()=> {
                  setShowStyleModal(true);
                  setActiveStyleId(filteredStyles[0].style_id);
                  setLinkId("footer")}}>
                <div style={{flex:2,flexDirection:"row",display:"flex"}}>
                  <div style={{justifyContent:"center"}}>
                    <picture>
                      <source
                        type="image/webp"
                        data-srcset={Helper.create_source_set({master:filteredStyles[0].picture_url,thumbnails:"1",},undefined,"webp")}
                        sizes="286px"
                        />
                      <source
                        type="image/png"
                        data-srcset={Helper.create_source_set({master:filteredStyles[0].picture_url,thumbnails:"1"})}
                        sizes="286px"
                        />

                    <img
                      className="lazyload"
                      css={{"@media (max-width:325px)":{height:50},transform: filteredStyles[0].mirror==="1" && "scaleX(-1)",objectFit:"contain",height:60}} alt={filteredStyles[0].name}
                      sizes="286px"
                      data-srcset={Helper.create_source_set({master:filteredStyles[0].picture_url,thumbnails:"1"})}/>
                    </picture>
                  </div>
                  <div style={{paddingLeft:10,flexDirection:"column",display:"flex",justifyContent:"center"}}>
                    <div style={{color:"#FF5A5F",fontWeight:"700",lineHeight:1,fontSize:18}}>
                      ${firstColorway.price}
                    </div>
                    <div style={{lineHeight:1.2,fontWeight:"500",color:"var(--grey-900)",fontSize:14}}>
                      on {firstColorway.shop_name}
                    </div>
                  </div>
                </div>
              </div>
              <div style={{flex:1,display:"flex",marginLeft:10,justifyContent:"flex-end",alignItems:"center"}}>
                <Link scroll={el => el.scrollIntoView({behavior: 'smooth', block: 'start'})}  to={"#colorways"}>
                  <div  style={{padding:"0px 15px",lineHeight:1.2,height:50,display:"flex",color:"white",alignItems:"center",fontSize:14,textAlign:"center",fontWeight:"700",backgroundColor:"#FF5A5F",flex:1,justifyContent:"center",borderRadius:5}}>
                    All {filteredStyles.length} styles
                  </div>
                </Link>
              </div>
            </div>
          </div>
      */}
        <Waypoint
          onPositionChange={(x) => {
            setCurrentFooterPosition(x.currentPosition);
          }}
        />
      </div>
    );
  } else {
    Helper.gaEvent("error", "shoe-reviews", "couldnt find shoe");
    return (
      <div style={{ marginTop: 20 }}>
        Couldn't find shoe. Go to <Link to={"/shoe-reviews/"}> all shoes </Link>
      </div>
    );
  }
}

export default connect(
  (state) => ({ ...state.data, ...state.persistData }),
  (dispatch) => ({
    actions: bindActionCreators(MetricActions, dispatch),
  })
)(Shoe);
